import { useState,useEffect,useLayoutEffect } from 'react'
import clsx from "clsx";
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import Logo from '../../images/destiny.png'


const capitalize = text => text.charAt(0).toUpperCase() + text.substr(1);
const clamp = value => Math.max(0, value);
const isBetween = (value, floor, ceil ) => value >= floor && value <= ceil;


const useScrollspy = (navigation, offset = 0) => {
  const [activeId, setActiveId] = useState("");

  useLayoutEffect(() => {
    const listener = () => {
      const scroll = window.pageYOffset;

      const position = navigation
        .map((item) => {
          const element = document.getElementById(item.href);

          if (!element) return { item, top: -1, bottom: -1 };

          const rect = element.getBoundingClientRect();
          const top = clamp(rect.top + scroll - offset);
          const bottom = clamp(rect.bottom + scroll - offset);

          return { item, top, bottom };
        })
        .find(({ top, bottom }) => isBetween(scroll, top, bottom));

      setActiveId(position?.item.href || "");
    };

    listener();

    window.addEventListener("resize", listener);
    window.addEventListener("scroll", listener);

    return () => {
      window.removeEventListener("resize", listener);
      window.removeEventListener("scroll", listener);
    };
  }, [navigation, offset]);

  return activeId;
};

const navigation = [
  { name: 'Home', href: 'home' },
  { name: 'Our actions', href: 'actions' },
  { name: 'About us', href: 'about' },
  { name: 'Contact us', href: 'contact' },
]

export default function Example() {;
  const activeId = useScrollspy(navigation, 80);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  
  const [navSize, setnavSize] = useState("10rem");
  const [navColor, setnavColor] = useState("transparent");
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavColor("#ffff") : setnavColor("transparent");
    window.scrollY > 10 ? setnavSize("5rem") : setnavSize("10rem");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  return (
    <div className="bg-white">
      <header className="fixed inset-x-0 top-0 z-50 bg-white" style={{
          backgroundColor: navColor,
          height: navSize,
          transition: "all 1s"}}>
        <nav className="flex items-center justify-between p-3 lg:px-8" aria-label="Global">
          <div className="flex lg:flex-1">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Destiny Focus Foundation</span>
              <img className="h-14 w-auto" src={Logo} alt=""/>
            </a>
          </div>
          <div className="flex lg:hidden">
            <div className="pr-6">
                <a href="#" className="text-sm bg-sky-600 p-2 px-4 rounded-md  text-white font-semibold leading-6">
                Donate <span aria-hidden="true">&rarr;</span>
                </a>
            </div>
            <button type="button"
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        onClick={() => setMobileMenuOpen(true)}>
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12 lg:flex-1">
            {/* {navigation.map((item) => (
              <a key={item.name} href={item.href} className="text-sm font-semibold leading-6 text-black">
                {item.name}
              </a>
            ))} */}
            {navigation.map((item) => (
                <a href={`#${item.href}`}
                    className={clsx(
                      "text-sm font-semibold leading-6 text-black",
                      item.href === activeId && "text-sm font-semibold leading-6 text-sky-600"
                    )}>
                  {capitalize(item.name)}
                </a>
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <a href="#" className="text-sm bg-sky-600 p-2 px-4 rounded-md  text-white font-semibold leading-6">
              Donate <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </nav>
        <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a href="/" className="-m-1.5 p-1.5">
                <span className="sr-only">Destiny Focus Foundation</span>
                <img className="h-14 w-auto" src={Logo} alt=""/>
              </a>          
              <button type="button" className="-m-2.5 rounded-md p-2.5 text-gray-700" onClick={() => setMobileMenuOpen(false)}>
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <a href={`#${item.href}`}
                          onClick={() => setMobileMenuOpen(false)}
                          className={clsx(
                            "-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-black hover:bg-gray-50",
                            item.href === activeId && "-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-sky-600 hover:bg-gray-50"
                          )}>
                      {item.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
    </div>
  )
}
